// Material Dashboard 2 React helper functions
import pxToRem from "theme/base/pxToRem";
import colors from "../colors";

const card = {
  styleOverrides: {
    root: {
      borderRadius: pxToRem(12),
      background: colors.background.bgPrimary,
      boxShadow: "none",
    },
  },
};

export default card;
